import React from 'react';
import './StaffDashboard.css';

const mockLog = [
  { id: 1, date: '2024-06-10', action: 'Completed Inspection: Fire Doors' },
  { id: 2, date: '2024-06-12', action: 'Submitted Incident Report' },
  { id: 3, date: '2024-06-15', action: 'Completed Task: Replace PPE' },
];

export default function ActivityLog() {
  return (
    <div className="overview-card">
      <h3>🧠 Activity Log</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {mockLog.map(item => (
          <li key={item.id} style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: 600 }}>{item.date}</div>
            <div>{item.action}</div>
          </li>
        ))}
      </ul>
    </div>
  );
} 